import {Component} from '@angular/core';
import {ChoiceBaseComponent} from '@shared/form/choice/choice-base.component';
import {LucideAngularModule} from 'lucide-angular';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';

@Component({
  selector: 'app-choice-radio-field',
  imports: [
    LucideAngularModule,
    FieldContainerComponent
  ],
  templateUrl: './choice-radio-field.component.html',
  styleUrl: './choice-radio-field.component.scss'
})
export class ChoiceRadioFieldComponent<valueT> extends ChoiceBaseComponent<valueT> {
}
